import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import { getOpsHealth } from "@/lib/api";

// Striscia salute sistema: semafori sempre visibili (lezione del 20/07:
// listener Telegram muto per 3 ore, scoperto dall'utente e non dal sistema).
export const SystemHealthStrip = () => {
  const [h, setH] = useState(null);

  useEffect(() => {
    const load = () => getOpsHealth().then(setH).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!h?.checks) return null;

  return (
    <div
      data-testid="system-health-strip"
      className="flex flex-wrap items-center gap-x-4 gap-y-1.5 rounded-lg border border-border/60 bg-card/40 px-4 py-2"
    >
      <Activity className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      {h.checks.map((c) => (
        <span
          key={c.key}
          data-testid={`health-${c.key}`}
          title={c.detail}
          className="flex cursor-default items-center gap-1.5 text-xs text-muted-foreground"
        >
          <span
            className={`h-2 w-2 rounded-full ${c.ok ? "bg-emerald-400" : "animate-pulse bg-red-500"}`}
          />
          {c.label}
        </span>
      ))}
    </div>
  );
};
